// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions
// tslint:disable:no-big-function
import { ScrollOrientation } from '@epicuro-next/ataraxia/scroll-buttons';
import { recommendationsPanelsLocaleKeys } from '@epicuro-next/constants/features/localization';
import { mergeMultipleConfigs } from '@epicuro-next/platform/dynamic-components-utils';

import { createInstanceWithChildren } from '../../../utils/dynamic-items-utils';
import { ScrollableRecommendationPanelBuilder } from '../../builders/scrollable-recommendation-panel-builder';
import {
  clearPaneContent,
  openConfigStripEventHandler,
  recommendationItemClickedEventHandler,
  recommendationItemShownEventHandler,
} from '../../events';
import { DEFAULT_ROOT_PROPERTIES } from '../../properties/default-root-properties';
import { PANEL_STYLING_PROPERTIES } from '../../properties/panel-styling-properties';
import { PANEL_TRACKING_PROPERTIES } from '../../properties/panel-tracking-properties';
import { PRODUCT_ITEM_VIEW_PROPERTIES } from '../../properties/product-item-view-properties';
import { SCROLLABLE_PANEL_PROPERTIES } from '../../properties/scrollable-panel-properties';
import { SUGGEST_PROVIDER_PROPERTIES } from '../../properties/suggest-provider-properties';
import { createDynamicBasketNotification } from '../common/basket-notification';

export function createAddedToBasketNotificationPanel() {
  const root = createInstanceWithChildren({
    id: 'root',
    contentTypeId: 'dynamic-collections-renderer',
    styles: {
      classes: ['d-flex', 'flex-column', 'h-100'],
      style: {
        width: '375px',
      },
    },
    data: {
      ...DEFAULT_ROOT_PROPERTIES,
      ...PANEL_TRACKING_PROPERTIES,
      ...PANEL_STYLING_PROPERTIES,
      ...PRODUCT_ITEM_VIEW_PROPERTIES,
      ...SCROLLABLE_PANEL_PROPERTIES,
      showProductHeader: true,
      headerText: recommendationsPanelsLocaleKeys.similarProductsYouMightLike,
      panelName: 'ConfigStrip',
      scrollOrientation: 'vertical',
      ...SUGGEST_PROVIDER_PROPERTIES,
    },
    children: [],
  });

  const basketNotification = createDynamicBasketNotification({
    withClearPaneOnNavigatingToBasketEvent: true,
    paneLocation: 'right',
  });
  root.children.push(basketNotification);

  const horizontalScrollablePanelRecommendatonPanelBuilder =
    new ScrollableRecommendationPanelBuilder().setOrientation(
      ScrollOrientation.vertical,
    );

  const horizontalScrollablePanelRecommendatonPanel =
    horizontalScrollablePanelRecommendatonPanelBuilder.build();

  root.children.push(
    horizontalScrollablePanelRecommendatonPanel.scrollablePanel,
  );

  const rootWithExtendedProperties = mergeMultipleConfigs(root, [
    {
      id: 'header-text',
      styles: {
        classes: ['h3', 'mt-2', 'mb-2', 'text-center'],
      },
    },
    {
      id: 'scrollable-item-content',
      styles: {
        classes: ['d-flex', 'item-content-type', 'mb-4'],
        style: {
          width: '100%',
        },
        variables: {
          '--pcard-header-value-display': 'block',
          '--product-prices-justify-content': 'flex-end',
        },
      },
    },
    {
      id: 'product-header',
      styles: {
        classes: ['mr-2'],
        style: {
          'text-align': 'right',
          width: '50%',
          flex: '0 0 50%',
        },
      },
    },
    {
      id: 'scrollable-panel-container',
      styles: {
        classes: [
          'scrollable-panel-container',
          'd-block',
          'position-relative',
          'overflow-hidden',
          'd-flex',
          'flex-column',
        ],
        style: {
          flex: 'auto',
        },
        variables: {
          '--pcard-title-id-margin': '0',
          '--scrollable-sub-container-padding': '0',
        },
      },
    },
    {
      id: 'sub-container',
      styles: {
        classes: ['h-100', 'd-block', 'overflow-hidden'],
      },
    },
    {
      id: 'scrollable-container',
      contentTypeId: 'dynamic-elements-scrollable-container',
      inputs: {
        offsetHeightMargin: 15,
      },
    },
    {
      id: 'item-media-preview',
      eventHandlers: {
        onClick: [
          recommendationItemClickedEventHandler(
            {
              provider: 'id:root',
              property: 'panelName',
            },
            {
              provider: 'id:root',
              property: 'panelTrackingId',
            },
            {
              provider: 'parent',
              property: 'productData',
            },
          ),
          openConfigStripEventHandler('parent', 'productData'),
          clearPaneContent('right'),
        ],
        onVisibleOnce: [
          recommendationItemShownEventHandler(
            {
              provider: 'id:root',
              property: 'panelName',
            },
            {
              provider: 'id:root',
              property: 'panelTrackingId',
            },
            {
              provider: 'parent',
              property: 'productData',
            },
          ),
        ],
      },
    },
  ])[0];
  return rootWithExtendedProperties;
}

export const addedToBasketNotificationPane =
  createAddedToBasketNotificationPanel();
